import { FileText, Download } from 'lucide-react';
import ContentWrapper from './ContentWrapper';
import { Button } from '@/components/ui/button';

// It doesn't work to download the file directly on click, probably CORS issue.
// Normal link href={url} target="_blank" works for now (see pdf in browser and download if the user wants to save it.)

type Props = {
  url: string;
  fileName: string;
};

const PurchaseOrderCard = ({ url, fileName }: Props) => {
  return (
    <ContentWrapper>
      <div className="flex gap-4 flex-row items-center w-full">
        <FileText className="size-5 text-muted-foreground shrink-0" />
        <div className="flex-1">
          <span>{fileName}</span>
        </div>
        <Button variant="ghost" size="icon" asChild>
          <a href={url} target="_blank" rel="noreferrer">
            <Download className="size-4 text-muted-foreground" />
          </a>
        </Button>
      </div>
    </ContentWrapper>
  );
};

export default PurchaseOrderCard;
